// config/seo.config.ts

export const seoConfig = {
  time: {
    title:
      "Pakistan Sehri & Iftar Time Today – Ramadan 2026 Roza Timings | Rozay",
    description:
      "Pakistan mein aaj ka Sehri time aur Iftar time dekhein. Ramadan 2026 ke liye major shehron ke roza timings daily update hoti hain. Complete Ramadan calendar aur moon sighting updates yahan available hain.",
    canonical: "https://rozay.today/",
  },
  timeCity: (city: string, slug: string) => ({
    title: `${city} Ramadan Timings 2026 Calendar - Today Sehri & Iftar | Rozay`,
    description: `${city} Sehri & Iftar time today with full Ramadan/Ramzan calendar 2026. Daily Sehr, Aftari, Roza timing schedule for ${city}, Pakistan with Hijri and Gregorian date context.`,
    canonical: `https://rozay.today/${slug}/`,
  }),

  calendar: {
    title: "Ramadan Calendar 2026 Pakistan | Complete Sehri & Iftar Schedule",
    description:
      "Ramadan 2026 roza calendar Pakistan - Ramazan complete schedule. Daily Sehri & Iftar timings, roza dates, moon sighting. Ramadan calendar Karachi, Lahore, Islamabad live.",
    canonical: "https://rozay.today/calendar/",
  },

  roza: {
    title: "Roza 2026 Guide - Islamic Rules, Niyat & Qaza (Pakistan)",
    description:
      "Roza guide 2026 - Islamic rules, niyat, qaza, kaffarah. Complete Ramadan rules in Urdu. Sehri & Iftar timings Pakistan, authentic Islamic practices.",
    canonical: "https://rozay.today/roza/",
  },

  zakat: {
    title: "Zakat Calculator Pakistan - Calculate 2.5% Online (PKR)",
    description:
      "Zakat calculator Pakistan: enter zakat-able wealth in PKR and instantly calculate 2.5% zakat online with Silver and Gold Nisab check.",
    canonical: "https://rozay.today/zakat/",
  },

  dua: {
    title: "Ramadan Duas 2026 | Sehri, Iftar & Taraweeh Prayers (Pakistan)",
    description:
      "Ramadan 2026 duas - Sehri dua, Iftar dua, Taraweeh dua in Arabic & Urdu. Lailatul Qadr duas, Islamic prayers for Ramzan. Free downloadable duas.",
    canonical: "https://rozay.today/dua/",
  },

  zikr: {
    title: "Zikr Counter 2026 | Digital Tasbih, Dhikr & Adhkar Tracker",
    description:
      "Simple Zikr counter for daily dhikr and tasbih. Track SubhanAllah, Alhamdulillah, Allahu Akbar counts after salah, morning and evening adhkar, and custom zikr targets.",
    canonical: "https://rozay.today/zikr/",
  },

  asma: {
    title: "99 Names of Allah – Asma ul Husna with Meaning",
    description:
      "99 Names of Allah (Asma ul Husna) with meaning in Urdu & English. Complete list of all 99 names with Arabic text and translation.",
    canonical: "https://rozay.today/asma/",
  },

  lailat: {
    title: "Lailatul Qadr 2026 | Night of Power Date & Guide (Pakistan)",
    description:
      "Lailatul Qadr 2026 - Shab-e-Qadr date Pakistan, Night of Power significance, when & how. Best ibadah practices, authentic duas, Ramadan 2026 spirituality.",
    canonical: "https://rozay.today/lailat/",
  },

  fitrana: {
    title: "Fitrana 2026 Pakistan | Amount in PKR & Payment Methods",
    description:
      "Fitrana 2026 amount PKR Pakistan - Zakat al-Fitr rate, who must pay. Fitrana payment methods, Fitrana calculator, complete Eid guide 2026.",
    canonical: "https://rozay.today/fitrana/",
  },

  "ramadan-start": {
    title: "Pakistan Mein Pehla Roza 2026 Kab Tha? Ramadan Start Date",

    description:
      "Ramadan 2026 Pakistan mein kab shuru hua? Pehla roza 19 February 2026 ko tha. Chand 18 February ki shaam nazar aya. Ramadan ki complete dates aur important details yahan dekhein.",
    canonical: "https://rozay.today/ramadan-start/",
  },
};
